@if (showSkeleton) {
<div class="app-skeleton-overlay">
  <app-skeleton-layout>
    <app-skeleton-summary-header />
    <app-skeleton-dashboard />
  </app-skeleton-layout>
</div>
}
<router-outlet />
